function init () {
  const elements = document.querySelectorAll('[data-video-section]')

  if (!elements.length) {
    return
  }

  const options = {
    threshold: 0.5
  }

  elements.forEach(element => {
    const button = element.querySelector('[data-video-button]')
    const video = element.querySelector('[data-video-media]')

    if (!video) {
      return
    }

    if (button) {
      button.addEventListener('click', () => {
        if (video.paused) {
          button.classList.remove('is-play')
          video.play()
          video.muted = false
        } else {
          button.classList.add('is-play')
          video.pause()
          video.muted = true
        }
      })
    }

    return observer(options).observe(element)
  })
}

function callback (entries, observer) {
  entries.forEach(entry => {
    const video = entry.target.querySelector('video')
    if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && video.dataset.autoplay === 'true') {
      video.play()
      video.muted = (video.dataset.muted === 'true')
    } else {
      video.pause()
      video.muted = true
    }
  })
}

function observer (options) {
  return new IntersectionObserver(callback, options)
}

export default init
